import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wind'
})
export class WindPipe implements PipeTransform {

  transform(speed: number | undefined, directionDeg: number | undefined): string {
    if (speed === undefined || speed === null || isNaN(speed)) {
      return '';
    }

    const roundedSpeed = Math.round(speed);

    if (!directionDeg) return `${roundedSpeed} km/h`;

    const dir = this.degreesToCompass(directionDeg);
    return `${dir} ${roundedSpeed} km/h`;
  }

  private degreesToCompass(deg: number): string {
    const directionsDE = [
      'N', 'NNO', 'NO', 'ONO', 'O', 'OSO', 'SO', 'SSO',
      'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'
    ];
    const index = Math.round(deg / 22.5) % 16;
    return directionsDE[index];
  }
}
